import React, { useState } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { useSearchParams, useNavigate } from "react-router-dom";

function ResetPassword() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get("token");

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({mode: "onChange",});

  const password = watch("password", "");

  const [showPass, setShowPass] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  // 🔒 PASSWORD STRENGTH
  const getStrength = (pwd) => {
    let score = 0;
    if (pwd.length >= 8) score++;
    if (/[A-Z]/.test(pwd)) score++;
    if (/[0-9]/.test(pwd)) score++;
    if (/[^A-Za-z0-9]/.test(pwd)) score++;
    return score;
  };

  const strength = getStrength(password);

  const strengthColors = ["#ef4444", "#f59e0b", "#3b82f6", "#22c55e"];
  const strengthLabels = ["Weak", "Fair", "Good", "Strong"];

  const onSubmit = async (data) => {
    setLoading(true);
    setStatus("");

    try {
      const res = await axios.post(`${API_BASE_URL}/auth/reset-password`, {
        token,
        password: data.password,
      });

      setStatus("Password updated successfully");

      setTimeout(() => navigate("/"), 1500);
    } catch (err) {
      setStatus(err?.response?.data?.message || "Reset failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="row">
      <div className="col-lg-5 d-none d-lg-flex vh-100 bg-primary-transparent align-items-center justify-content-center">
        <img src="/assets/img/authentication-reset-bg-06.svg" alt="" />
      </div>

      <div className="col-lg-7 d-flex align-items-center justify-content-center vh-100">
        <div className="col-md-7">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="text-center mb-4">
              <img src="/assets/img/logo.svg" alt="Logo" />
            </div>

            <h3 className="text-center">Reset Password</h3>

            {/* PASSWORD */}
            <div className="mb-3">
              <label>Password</label>
              <div className="input-group">
                <input
                  type={showPass ? "text" : "password"}
                  className="form-control"
                  {...register("password", { required: true })}
                />

                <span
                  className="input-group-text"
                  style={{ cursor: "pointer" }}
                  onClick={() => setShowPass(!showPass)}
                >
                  <i className={`ti ${showPass ? "ti-eye-off" : "ti-eye"}`}></i>
                </span>
              </div>

              {/* 🔒 STRENGTH BAR */}
              {password && (
                <>
                  <div style={{ display: "flex", marginTop: 6 }}>
                    {[1, 2, 3, 4].map((i) => (
                      <div
                        key={i}
                        style={{
                          height: 6,
                          flex: 1,
                          marginRight: 4,
                          borderRadius: 4,
                          background:
                            i <= strength
                              ? strengthColors[strength - 1]
                              : "#e5e7eb",
                        }}
                      />
                    ))}
                  </div>
                  <small style={{ color: strengthColors[strength - 1] }}>
                    {strengthLabels[strength - 1]}
                  </small>
                </>
              )}
            </div>

            {/* CONFIRM */}
            <div className="mb-3">
              <label>Confirm Password</label>
              <div className="input-group">
                <input
                  type={showConfirm ? "text" : "password"}
                  className="form-control"
                  {...register("confirmPassword", {
                    validate: (value) =>
                      value === password || "Passwords do not match",
                  })}
                />

                <span
                  className="input-group-text"
                  style={{ cursor: "pointer" }}
                  onClick={() => setShowConfirm(!showConfirm)}
                >
                  <i
                    className={`ti ${showConfirm ? "ti-eye-off" : "ti-eye"}`}
                  ></i>
                </span>
              </div>
              {errors.confirmPassword && (
                <small className="text-danger">
                  {errors.confirmPassword.message}
                </small>
              )}
            </div>

            <button className="btn btn-primary w-100" disabled={loading}>
              {loading ? "Submitting..." : "Submit"}
            </button>

            {status && <div className="text-center mt-2">{status}</div>}
          </form>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
